import React from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../Gym-Detail/GymDetail";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderimage from "../image/placeholder.jpg";
import Loader from "./Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeaturedGym } from "../redux/slice/FeaturedGym";

export default function FeaturedGym() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { featuredGymData, isLoading, isError } = useSelector(
    (state) => state.FeaturedGym
  );

  useEffect(() => {
    dispatch(fetchFeaturedGym());
  }, [dispatch]);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 5,
      slidesToSlide: 2,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 4,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 769 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1.5,
      slidesToSlide: 1,
    },
  };
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Carousel
          responsive={responsive}
          swipeable={true}
          draggable={true}
          infinite={false}
          showDots={false}
          autoPlay={false}
          autoPlaySpeed={3000}
          removeArrowOnDeviceType={["mobile"]}
        >
          {featuredGymData.map((bussinessData) => {
            return (
              <div className="card-slider" key={bussinessData.id}>
                <Link
                  to={`/${bussinessData.slug}`}
                  className="text-decoration-none"
                >
                  <div className="card border-0 card-carousel">
                    <LazyLoadImage
                      src={bussinessData.thumbnail_image || placeholderimage}
                      placeholderSrc={placeholderimage}
                      onError={(e) => { e.target.src = placeholderimage; }}
                      className="gym-pic"
                      loading="lazy"
                      alt={bussinessData.name}
                    />
                    <div className="card-body">
                      <div className="row gym-section">
                        <div className="col-12">
                          <h3 className="gym-name text-black text-start">
                            {bussinessData.name}
                          </h3>
                        </div>
                        {/* <div className="col-3">
                        <div className="rating-btn">
                          <p className="text-white text-center">4.4</p>
                        </div>
                      </div> */}
                      </div>
                      <div className="d-flex flex-row  gym-loc">
                        <i className="bi bi-geo-alt text-secondary"></i> &nbsp;
                        <p className="mt-0 text-secondary card-txt1">
                          {bussinessData.area} {bussinessData.city}
                        </p>
                      </div>
                      <h3 className="text-dark card-txt2">
                        Available Workouts
                      </h3>
                      <div className="category-tags-container">
                        {bussinessData.category.map((cat) => {
                          return (
                            <span key={cat.id} className="category-tag">
                              {cat.name}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </Carousel>
      )}
    </>
  );
}
